module.exports = __webpack_public_path__ + "media/bootstrap-icons/dash-lg-7e0db40d.svg";